<template lang="pug">
.tabela-listar-territorio-monitoramento
    .tabela-conteudo(:class='{ "largura-total": larguraTotal }')
        el-table(
            ref='multiplaSelecao',
            :data='paginaAreasMonitoradas.resultados',
            stripe,
            style='width: 100%',
            @selection-change='atualizarLinhasSelecionadas',
            @sort-change='ordenar'
        )
            el-table-column(type='expand', v-if='!larguraTotal')
                template(slot-scope='scope')
                    .box-espande-listagem
                        .box-espande-listagem-box
                            .box-espande-listagem-box-texto
                                | CAR:
                            .box-espande-listagem-box-value
                                | {{ formatarCar(scope.row.territorio.cars.length ? scope.row.territorio.cars[0].codigo : null) }}

                                el-popover(placement='bottom', trigger='hover')
                                    el-tag.ml-2(
                                        v-if='Object.keys(scope.row.territorio.cars).length',
                                        size='mini',
                                        slot='reference'
                                    ) {{ scope.row.territorio.cars.length }}
                                    .lista-scroll
                                        div(
                                            v-for='(car, index) in scope.row.territorio.cars',
                                            :key='index'
                                        ) {{ car.codigo }}

                        .box-espande-listagem-box
                            .box-espande-listagem-box-texto
                                | Pessoas:
                            .box-espande-listagem-box-value(
                                v-if='scope.row.territorio.representantes.length > 0',
                                v-for='representante in scope.row.territorio.representantes'
                            )
                                | {{ representante.nomeRazaoSocial }}
                            .box-espande-listagem-box-value(
                                v-if='scope.row.territorio.representantes.length === 0'
                            )
                                | {{ '-' }}

                        .box-espande-listagem-box
                            .box-espande-listagem-box-texto
                                | Área:
                            .box-espande-listagem-box-value
                                | {{ formatAreaHa(scope.row.areaHa) }}

            el-table-column(type='selection', width='55')

            el-table-column(label='Território', sortable)
                template(slot-scope='scope')
                    span {{ scope.row.territorio.nome }}

            el-table-column(v-if='larguraTotal', label='Área', sortable)
                template(slot-scope='scope')
                    span {{ formatAreaHa(scope.row.areaHa) }}

            el-table-column(label='Localidade', sortable)
                template(slot-scope='scope')
                    span {{ scope.row.territorio.localidade }}

            el-table-column(v-if='larguraTotal', label='Pessoas', sortable)
                template(slot-scope='scope')
                    span {{ scope.row.territorio.representantes.length ? scope.row.territorio.representantes[0].nomeRazaoSocial : '-' }}
                        el-popover(placement='bottom', trigger='hover')
                            el-tag.ml-2(
                                v-if='Object.keys(scope.row.territorio.representantes).length > 1',
                                size='mini',
                                slot='reference'
                            ) {{ scope.row.territorio.representantes.length }}
                            .lista-scroll
                                div(
                                    v-for='(representante, index) in scope.row.territorio.representantes',
                                    :key='index'
                                ) {{ representante.nomeRazaoSocial }}

            el-table-column(v-if='larguraTotal', label='CAR', sortable)
                template(slot-scope='scope')
                    span {{ formatarCar(scope.row.territorio.cars.length ? scope.row.territorio.cars[0].codigo : null) }}
                        el-popover(placement='bottom', trigger='hover')
                            el-tag.ml-2(
                                v-if='Object.keys(scope.row.territorio.cars).length',
                                size='mini',
                                slot='reference'
                            ) {{ scope.row.territorio.cars.length }}

                            .lista-scroll
                                div(
                                    v-for='(car, index) in scope.row.territorio.cars',
                                    :key='index'
                                ) {{ car.codigo }}

            el-table-column(label='Não conformidades', width='230', sortable)
                template(slot-scope='scope')
                    span(v-if='scope.row.diagnosticoSocioambiental') {{ scope.row.diagnosticoSocioambiental.possuiRestricao || scope.row.diagnosticoSocioambiental.representantePossuiRestricao || scope.row.diagnosticoSocioambiental.carPossuiRestricao ? 'Sim' : 'Não' }}
                    span(v-else) -

            el-table-column(label='Ações', width='100', align='center')
                template(slot-scope='scope')
                    el-dropdown(trigger='click')
                        span
                            i.mdi.mdi-dots-vertical.mudando-cursor
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarAreaMonitorada(scope.row)'
                            ) Visualizar

                            el-dropdown-item(
                                icon='el-icon-delete',
                                @click.native='desativarAreaMonitorada(scope.row)'
                            ) Desativar

    .tabela-rodape
        .tabela-rodape--esquerda
            p {{ linhasSelecionadas.length }} selecionado de {{ paginaAreasMonitoradas.totalResultados }} territórios

        .tabela-rodape--pagination
            el-pagination(
                background,
                small,
                layout='prev, pager, next',
                :page-size='paginacao.tamanho',
                :current-page.sync='paginacao.pagina + 1',
                :total='paginaAreasMonitoradas.totalResultados',
                @current-change='mudarPagina'
            )

    .tabela-btn
        el-button.button-outline(
            type='primary',
            icon='el-icon-video-pause',
            :disabled='!linhasSelecionadas.length',
            @click='desativarMonitoramentos'
        ) Desativar monitoramento

    ModalDesativarMonitoramento(
        :mostrar='mostraModalDeasativarAreaMonitorada',
        :areasMonitoradas='areasMonitoradasDesativar',
        @atualizarTabela='atualizarTabela',
        @fechar='mostraModalDeasativarAreaMonitorada = false'
    )
</template>

<script>
import ModalDesativarMonitoramento from '@/components/monitoramento/ModalDesativarMonitoramento.vue';
import formatters from '@/utils/formatters';

export default {
    name: 'TabelaListarTerritorioMonitoramento',

    props: {
        paginaAreasMonitoradas: {
            type: Object,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        larguraTotal: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    components: {
        ModalDesativarMonitoramento
    },

    data() {
        return {
            linhasSelecionadas: [],
            ordenacao: '',
            areasMonitoradasDesativar: [],
            mostraModalDeasativarAreaMonitorada: false
        };
    },

    watch: {
        paginaAreasMonitoradas() {
            this.linhasSelecionadas = [];
        }
    },

    methods: {
        atualizarLinhasSelecionadas(linhasSelecionadas) {
            this.linhasSelecionadas = linhasSelecionadas;
        },

        formatarCar(codigo) {
            if (!codigo) return '-';

            return formatters.reduzirCar(codigo);
        },

        ordenar({ column, order }) {
            const nomesColunas = {
                Território: 't.nome',
                Município: 'm.nome',
                'Não conformidades': 'ds.possui_restricao'
            };
            this.ordenacao = nomesColunas[column.label];

            let sentido = '';
            if (order === 'ascending') sentido = ',asc';
            if (order === 'descending') sentido = ',desc';

            this.ordenacao += sentido;
            this.$emit('ordenar', this.ordenacao);
        },

        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },

        atualizarTabela() {
            this.mudarPagina(0);
        },

        desativarAreaMonitorada({ id }) {
            const areaMonitoradaDesativar =
                this.paginaAreasMonitoradas.resultados.find(
                    areaMonitorada => areaMonitorada.id === id
                );

            this.areasMonitoradasDesativar = [areaMonitoradaDesativar];
            this.mostraModalDeasativarAreaMonitorada = true;
        },

        desativarMonitoramentos() {
            this.areasMonitoradasDesativar = this.linhasSelecionadas;
            this.mostraModalDeasativarAreaMonitorada = true;
        },

        visualizarAreaMonitorada({ id }) {
            this.$router.push({
                name: 'VisualizarMonitoramentoSocioambiental',
                params: { idAreaMonitorada: id }
            });
        },

        formatAreaHa(areaHa) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        }
    }
};
</script>

<style lang="scss">
.tabela-listar-territorio-monitoramento {
    .tabela-conteudo {
        height: 572px;
        overflow-y: auto;
        padding: 0px 5px;
        background-color: var(--white);
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        border-radius: 6px;

        &.largura-total {
            height: 100% !important;
        }

        .el-table {
            box-shadow: 0px 1px 5px 0px var(--block-shadow);
            border-radius: 6px;
        }
        .el-table thead {
            font-weight: 400;
            font-size: 13px;
        }
    }

    .tabela-btn {
        margin-top: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 41% 10px 5px;
        margin-top: 6px;
        border-radius: 6px;
        box-shadow: 0px 3px 5px 0px var(--block-shadow);
        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
            margin-left: 10px;
        }
        .tabela-rodape--pagination {
            .el-pager li.active {
                color: var(--white);
                font-weight: 900;
                background: var(--primary);
            }

            .el-pager li {
                padding: 0 4px;
                background: var(--white);
                vertical-align: top;
                display: inline-block;
                font-size: 13px !important;
                min-width: 28px !important;
                height: 28px !important;
                line-height: 28px !important;
                box-sizing: border-box;
                text-align: center;
                margin: 0;
                border-radius: 2px;
                color: var(--primary);
            }

            .el-pagination button {
                height: 28px;
            }
        }
    }

    .box-espande-listagem {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 15px;
        margin-bottom: 15px;

        .box-espande-listagem-box {
            .box-espande-listagem-box-texto {
                font-weight: 600;
                color: var(--primary);
            }
            .box-espande-listagem-box-value {
                font-weight: 400;
                color: var(--primary);
            }
        }
    }

    .mudando-cursor {
        cursor: pointer;
    }
}
.button-green {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}
.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    i.lyra-icon::before {
        width: 13px !important;
        height: 13px !important;
        background: var(--primary) !important;
        margin-right: 6px;
    }
}
.lista-car-popover {
    margin-bottom: 1px;
}
.el-tag.tag-car {
    margin-left: 5px;
}

.lista-scroll {
    max-height: 300px;
    overflow-y: auto;
    flex-direction: column;
    padding: 5px 10px;

    /* width */
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: var(--text-disabled);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }
}
</style>
